import { useId } from 'react'
import { useEventEmails, useSetEventEmails } from '~/entities/business/model/use-event-emails'
import * as m from '~/paraglide/messages'
import { Label } from '~/shared/ui/label'
import { Switch } from '~/shared/ui/switch'

export function EventEmailsSwitch() {
  const { data, isLoading } = useEventEmails()
  const { mutate, isPending } = useSetEventEmails()
  const id = useId()
  if (!isLoading && !data) return null

  return (
    <div className="flex items-start justify-between gap-4">
      <div className="space-y-1">
        <Label htmlFor={id} className="font-medium text-sm">
          {m.eventEmailsSetting()}
        </Label>
        <p className="text-muted-foreground text-sm">{m.eventEmailsSettingHint()}</p>
      </div>
      <Switch
        id={id}
        checked={data?.enabled ?? true}
        disabled={isLoading || isPending}
        onCheckedChange={(checked) => mutate(checked)}
      />
    </div>
  )
}
